import { render, staticRenderFns } from "./toolbar-compact.vue?vue&type=template&id=a5e4faba&"
import script from "./toolbar-compact.vue?vue&type=script&lang=js&"
export * from "./toolbar-compact.vue?vue&type=script&lang=js&"
import style0 from "./toolbar-compact.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\uds\\projects\\alpheios\\components\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a5e4faba', component.options)
    } else {
      api.reload('a5e4faba', component.options)
    }
    module.hot.accept("./toolbar-compact.vue?vue&type=template&id=a5e4faba&", function () {
      api.rerender('a5e4faba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/nav/toolbar-compact.vue"
export default component.exports